<template>
  <v-flex xs12>
    <v-container>
      <v-layout row wrap>
        <v-slide-x-transition mode="out-in">
          <v-flex
            xs12
            sm4
            v-if="!flags.addRole"
            :key="1"
            class="expandableContainer"
          >
            <v-list two-line>
              <draggable
                v-model="webRoles"
                group="people"
                @start="drag = true"
                @end="drag = false"
                draggable=".itemDrag"
              >
                <v-slide-y-transition class="two-line subheader" group>
                  <template v-for="element in webRoles">
                    <v-hover :key="element.id">
                      <v-list-tile
                        avatar
                        :class="
                          'pa-2 mb-3 elevation-1 ' +
                          (select.webRole.id == element.id
                            ? 'gradiente '
                            : 'grey lighten-5 ') +
                          (element.hierachy != 0
                            ? 'itemDrag '
                            : '' + ` elevation-${hover ? 4 : 0}`)
                        "
                        style="border-radius: 5px"
                        slot-scope="{ hover }"
                        :disabled="edittingOrDeleting"
                        @click="selectRole(element)"
                      >
                        <v-expand-transition v-if="element.hierachy == 0">
                          <div
                            v-if="hover"
                            :class="
                              hierachySelected != 0
                                ? 'd-flex transition-fast-in-fast-out darken-2 v-card--reveal display-1'
                                : 'd-flex transition-fast-in-fast-out darken-2 v-card--reveal display-1 white--text'
                            "
                            style="
                              height: 100%;
                              width: 90%;
                              border-radius: 20px;
                              z-index: 1;
                              color: #ef565c;
                            "
                          >
                            No editable
                          </div>
                        </v-expand-transition>

                        <v-list-tile-avatar>
                          <v-icon
                            :color="
                              select.webRole.id == element.id
                                ? 'white'
                                : 'primary'
                            "
                            large
                            >supervised_user_circle</v-icon
                          >
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title
                            xs4
                            md4
                            lg4
                            v-if="!flags.rEditing"
                            :class="
                              select.webRole.id == element.id
                                ? 'white--text'
                                : ''
                            "
                            v-text="element.name"
                          ></v-list-tile-title>
                        </v-list-tile-content>
                        <v-list-tile-action v-if="element.hierachy == 0">
                          <v-icon color="red lighten-1">security</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-action v-else>
                          <v-edit-dialog
                            :return-value.sync="updating.rolName"
                            lazy
                            large
                            @save="saveNewName"
                            @cancel="cancelWindow"
                            @close="close"
                            :save-text="$t('generic.accept')"
                            :cancel-text="$t('generic.cancel')"
                          >
                            <v-btn
                              icon
                              v-if="
                                permits['UPDATE_PERMITS'] &&
                                element.hierachy != 0
                              "
                              :disabled="edittingOrDeleting"
                              @click="open(element)"
                              class="roundBtns"
                            >
                              <v-icon color="red lighten-1" class="marginIcon"
                                >edit</v-icon
                              >
                            </v-btn>
                            <template v-slot:input>
                              <v-text-field
                                v-model="updating.rolName"
                                label="Editar nombre"
                                counter
                                :error-messages="processErrorNameUpdate"
                                required
                              ></v-text-field>
                            </template>
                          </v-edit-dialog>

                          <v-edit-dialog
                            :return-value.sync="updating.rolName"
                            lazy
                            large
                            @save="deletePermanent"
                            @cancel="cancelWindowDelete"
                            @close="closeDelete"
                            :save-text="$t('generic.accept')"
                            :cancel-text="$t('generic.cancel')"
                          >
                            <v-btn
                              id="BotonBorrado"
                              v-if="
                                permits['DELETE_ROLE'] && element.hierachy != 0
                              "
                              :disabled="edittingOrDeleting"
                              @click="assignElementToDelete(element)"
                              icon
                              class="roundBtns"
                            >
                              <v-icon color="red lighten-1" class="marginIcon"
                                >delete</v-icon
                              >
                            </v-btn>
                            <template v-slot:input>
                              <v-flex mt-4>{{
                                'Este rol no existirá más. ¿Está seguro de realizar está acción?'
                              }}</v-flex>
                            </template>
                          </v-edit-dialog>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-hover>
                  </template>
                </v-slide-y-transition>
              </draggable>
            </v-list>
          </v-flex>
          <v-flex
            xs12
            sm4
            v-if="flags.addRole"
            :key="2"
            class="expandableContainer"
          >
            <v-form ref="RoleForm" lazy-validation @submit.prevent="addRole">
              <v-container>
                <v-layout row wrap>
                  <p>Datos del Rol:</p>
                  <v-flex xs12>
                    <v-text-field
                      v-model="formRole.name"
                      @blur="$v.formRole.name.$touch()"
                      label="Nombre"
                      :error-messages="processErrorName"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn @click="cancel" large round>{{
                      $t('generic.cancel')
                    }}</v-btn>
                    <v-btn
                      class="gradiente white--text"
                      type="submit"
                      large
                      round
                    >
                      {{ $t('generic.save') }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-flex>
        </v-slide-x-transition>
        <v-slide-x-transition>
          <v-flex xs12 sm8 v-show="select.webRole.id != null">
            <v-expansion-panel>
              <v-expansion-panel-content
                v-for="item in sections"
                :key="item.id"
              >
                <template v-slot:header>
                  <v-layout align-center justify-center row fill-height>
                    <v-flex xs2 sm1>
                      <v-img
                        :src="require('@/assets/panel/home/' + item.img)"
                        style="width: 30px; height: 30px; margin-right: 15px"
                      ></v-img>
                    </v-flex>
                    <v-flex xs10 sm11>
                      <span class="body-2">
                        <b>{{ item.name }}</b>
                      </span>
                    </v-flex>
                  </v-layout>
                </template>
                <v-card>
                  <v-layout wrap>
                    <v-flex xs12>
                      <DataRole
                        :items="getFilterCatalogs(select.webRole, item)"
                        :headers="headers"
                        :permits="permits"
                        :disabled="isDisableProperty(item)"
                        :approved="filterCatalogs(select.webRole, item)"
                        v-on:chck="updateCatalogsRole($event, true)"
                        v-on:uChck="updateCatalogsRole($event, false)"
                        v-on:chckAll="updateCatalogsRoleAll($event, true)"
                        v-on:uChckAll="updateCatalogsRoleAll($event, false)"
                      ></DataRole>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
        </v-slide-x-transition>
      </v-layout>
    </v-container>
    <loading v-model="working.wLoading" text="Trabajando"></loading>
    <success v-model="toast.success" text="Operación Exitosa"></success>
    <error v-model="toast.failed" :text="textToast.failed"></error>
  </v-flex>
</template>

<script>
import draggable from 'vuedraggable'
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import { sections } from '../../../Catalogs/RoleCatalogs'
import { isEmptyOrNull, isNormalSchool } from '../../../plugins/GeneralMethods'
import error from '../../Dialogs/Error.vue'
import loading from '../../Dialogs/Loading.vue'
import success from '../../Dialogs/Success.vue'
import DataRole from './DataTableRole.vue'
export default {
  components: {
    loading,
    success,
    error,
    draggable,
    DataRole,
  },
  props: ['addFlag', 'updateFlag', 'permits'],
  watch: {
    addFlag() {
      this.flags.addRole = this.addFlag
    },
    updateFlag() {
      if (this.updateFlag) {
        this.updateWebRoles()
      }
    },
    getWebRoles() {
      this.webRoles = this.getWebRoles
    },
    permits() {
      this.$forceUpdate()
    },
  },
  validations: {
    formRole: {
      name: { required },
    },
  },
  data: () => ({
    webRoles: [],
    showDelete: false,
    textToast: {
      failed: '',
    },
    edittingOrDeleting: false,
    select: {
      webRole: {},
      updRol: {},
    },
    toast: {
      success: false,
      failed: false,
    },
    working: {
      wRole: false,
    },
    headers: [
      {
        text: 'Nombre',
        align: 'left',
        value: 'name',
      },
    ],
    flags: {
      addRole: false,
      rEditing: false,
      notRepeatedName: true,
    },
    formRole: {
      name: '',
    },
    updating: {
      rolName: '',
    },
    roleToDelete: {},
    hierachySelected: -1,
    modulesEnable: [2, 3, 6, 13],
  }),
  mounted() {
    this.fetchWebRoles()
    this.fetchCatalogs()
  },
  methods: {
    isDisableProperty(item) {
      if (this.select.webRole.hierachy == 0) {
        return true
      } else if (isNormalSchool(this.getBranch)) {
        return false
      } else {
        let i = this.modulesEnable.find((it) => it == item.id)
        if (isEmptyOrNull(i)) {
          return true
        } else {
          return false
        }
      }
    },
    cancel() {
      this.$refs.RoleForm.reset()
      this.$emit('cancel')
    },
    selectRole(element) {
      if (this.select.webRole.catalogs != null) {
        for (var r in this.webRoles) {
          if (this.select.webRole.id == this.webRoles[r].id) {
            this.webRoles[r].catalogs = this.select.webRole.catalogs
            break
          }
        }
      }
      this.select.webRole = element
      this.hierachySelected = element.hierachy
    },
    addRole() {
      this.$v.formRole.$touch()
      if (!this.$v.formRole.$invalid && this.flags.notRepeatedName) {
        this.working.wRole = true
        var json = JSON.stringify(this.formRole) // aqui tienes la lista de objetos en Json
        var obj = JSON.parse(json)
        this.$store
          .dispatch('webRole/createRole', obj)
          .then(() => {
            this.working.wRole = false
            this.toast.success = true
            this.cancel()
          })
          .catch((error) => {
            this.working.wRole = false
            this.textToast.failed = 'Ocurrió un problema'
            this.toast.failed = true
            console.log(error)
          })
      }
    },

    validateRol(name) {},

    fetchWebRoles() {
      this.$store
        .dispatch('webRole/getWebRoles')
        .then((response) => {
          this.webRoles = response.data.entity
        })
        .catch((error) => {
          console.log(error)
        })
    },
    fetchCatalogs() {
      this.$store.dispatch('webRole/getCatalogs')
    },
    filterCatalogs(role, item) {
      var filterCatalogs = []
      if (role.catalogs != null) {
        var catalogs = role.catalogs
        for (var c in catalogs) {
          if (item.key.includes(catalogs[c].name.split('_')[1])) {
            filterCatalogs.push(catalogs[c])
          }
        }
      }
      return filterCatalogs
    },
    getFilterCatalogs(role, item) {
      var filterCatalogs = []
      var catalogs = this.getCatalogs,
        catalog
      for (var i in catalogs) {
        catalog = catalogs[i]
        if (item.key.includes(catalog.name.split('_')[1])) {
          filterCatalogs.push(catalog)
        }
      }

      return filterCatalogs
    },
    updateCatalogsRole(event, flag) {
      if (flag) {
        this.select.webRole.catalogs.push(event)
      } else {
        for (var i in this.select.webRole.catalogs) {
          if (this.select.webRole.catalogs[i].id == event.id) {
            this.select.webRole.catalogs.splice(i, 1)
            break
          }
        }
      }
    },
    updateCatalogsRoleAll(event, flag) {
      if (flag) {
        for (var i in event) {
          if (!this.select.webRole.catalogs.includes(event[i])) {
            this.select.webRole.catalogs.push(event[i])
          }
        }
      } else {
        for (var j in event) {
          for (var i in this.select.webRole.catalogs) {
            if (this.select.webRole.catalogs[i].id == event[j].id) {
              this.select.webRole.catalogs.splice(i, 1)
              break
            }
          }
        }
      }
    },
    updateWebRoles() {
      for (var r in this.webRoles) {
        this.webRoles[r].hierachy = parseInt(r)
        if (this.select.webRole.id == this.webRoles[r].id) {
          this.webRoles[r].catalogs = this.select.webRole.catalogs
        }
      }
      var json = JSON.stringify(this.webRoles) // aqui tienes la lista de objetos en Json
      var obj = JSON.parse(json)
      this.$store
        .dispatch('webRole/updateRoles', obj)
        .then(() => {
          this.$emit('success', true)
        })
        .catch(() => {
          this.$emit('failed', true)
        })
    },
    editRolName(item) {
      if (this.permits['UPDATE_SETTINGS'] && !this.flags.rEditing) {
        this.flags.rEditing = true
        this.updating.rolName = item.name
        this.select.updRol = item
      }
    },
    saveNewName() {
      if (
        this.permits['UPDATE_SETTINGS'] &&
        this.flags.notRepeatedName &&
        this.updating.rolName
      ) {
        this.webRoles[this.webRoles.indexOf(this.select.updRol)].name =
          this.updating.rolName
      } else {
        this.updating.rolName = 'No autorizado'
      }
    },
    cancelWindow() {
      this.updating.rolName = ''
      this.edittingOrDeleting = false
    },
    open(item) {
      if (this.permits['UPDATE_SETTINGS']) {
        this.edittingOrDeleting = true
        this.updating.rolName = item.name
        this.select.updRol = item
      } else {
        this.updating.rolName = 'No autorizado'
      }
    },
    close() {
      this.edittingOrDeleting = false
      this.updating.rolName = ''
      if (
        !this.flags.notRepeatedName &&
        this.updating.rolName != this.select.updRol.name
      ) {
        this.toast.failed = true
        this.textToast.failed = 'Nombre repetido'
        this.flags.notRepeatedName = true
      }
    },
    assignElementToDelete(item) {
      this.edittingOrDeleting = true
      this.roleToDelete = item
    },
    deletePermanent() {
      this.$store
        .dispatch('webRole/deleteRole', this.roleToDelete.id)
        .then((_) => {
          this.fetchWebRoles()
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.toast.failed = true
            this.textToast.failed =
              'No es posible eliminar este rol, ya que cuenta con colaboradores asociados, verifícalos en la sección de colaboradores y vuelve a intentarlo'
          }
        })
    },
    closeDelete() {
      this.edittingOrDeleting = false
      this.roleToDelete = {}
      this.$forceUpdate()
    },
    cancelWindowDelete() {
      this.edittingOrDeleting = false
      this.roleToDelete = {}
      this.$forceUpdate()
    },
  },
  computed: {
    sections() {
      return sections
    },
    processErrorName() {
      const errors = []
      var json = JSON.stringify(this.formRole) // aqui tienes la lista de objetos en Json
      var obj = JSON.parse(json)
      for (const [i, it] of this.webRoles.entries()) {
        if (it.name == obj.name) {
          errors.push('El nombre del rol ya existe', i)
          this.flags.notRepeatedName = false
          return errors
        }
      }
      this.flags.notRepeatedName = true
      if (!this.$v.formRole.name.$dirty) return errors

      !this.$v.formRole.name.required &&
        errors.push('El nombre del rol es requerido')
      return errors
    },
    processErrorNameUpdate() {
      const errors = []
      for (const [i, it] of this.webRoles.entries()) {
        if (
          it.name == this.updating.rolName &&
          this.updating.rolName != this.select.updRol.name
        ) {
          errors.push('El nombre del rol ya existe', i)
          this.flags.notRepeatedName = false
          return errors
        }
      }
      this.flags.notRepeatedName = true
      return errors
    },

    //Mappers
    ...mapGetters(['getWebRoles', 'getCatalogs', 'getBranch']),
  },
}
</script>

<style>
.roundBtns {
  width: 300% !important;
}

.text--primary {
  color: 'primary';
}

.v-small-dialog {
  width: 24px !important;
  height: 24px !important;
}
</style>
